<template>
	<div v-if="visible" class="promo-step__section promo-step__section--plan">
		<v-switch :key="attempt" :model-value="onPlan" color="success" hide-details density="compact" :disabled="snapshot.consultation" class="flex-grow-0" @update:model-value="onToggle" />
		<div class="text-high-emphasis">
			<div class="text-body-medium font-weight-bold">{{ t('DisplayOnPromoPDV') }}</div>
			<div class="text-body-small text-medium-emphasis">{{ t('PromoPlanSwitchHint') }}</div>
		</div>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { isOfferOnPromoPlan, isPromoPlanSwitchVisible } from '@/utils/domain/promo/promoPlan';

const props = defineProps({
	campaign: { type: Object, required: true },
	offerRef: { type: Object, required: true },
});

const { snapshot, ops, t } = usePromoStep();
const attempt = ref(0);

const visible = computed(() => isPromoPlanSwitchVisible(snapshot.value, props.campaign, props.offerRef));
const onPlan = computed(() => isOfferOnPromoPlan(snapshot.value, props.offerRef));

function onToggle(value) {
	if (!ops.setPromoPlan(props.offerRef, !!value)) attempt.value += 1;
}
</script>
